module.exports = __webpack_public_path__ + "static/2-953991c415b7c43ef3e42677a8077ac3.jpg";